import { Counter, Panel } from '../ui';
import './Stats.css';

/* ============================================================================
   Stats — the HUD readout.

   Shows the guess count next to a progress meter for the title itself. The
   meter is the useful half: guess count alone never tells you whether you're
   close, and "3 of 5 title words found" is the actual state of play.
   ========================================================================== */

function Stats({ guessCount, found = 0, total = 0 }) {
  const percent = total > 0 ? Math.round((found / total) * 100) : 0;
  const isClose = total > 0 && total - found === 1;

  return (
    <Panel variant="inset" className="stats">
      <Counter value={guessCount} label="Guesses" tone="red" size="sm" />

      <div className="stats__meter">
        <div className="stats__meter-head">
          <span className="u-label">Title decrypted</span>
          <span className={`stats__meter-value ${isClose ? 'is-close' : ''}`}>
            {found}/{total || '?'}
          </span>
        </div>

        <div
          className="stats__track"
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Title words found"
        >
          <div
            className={`stats__fill ${isClose ? 'is-close' : ''}`}
            style={{ width: `${percent}%` }}
          >
            <span className="stats__fill-tip" />
          </div>
          {/* Tick marks, one per word of the title. */}
          <div className="stats__ticks" aria-hidden="true">
            {Array.from({ length: Math.max(total - 1, 0) }, (_, i) => (
              <span key={i} style={{ left: `${((i + 1) / total) * 100}%` }} />
            ))}
          </div>
        </div>
      </div>

      <Counter value={`${percent}%`} label="Signal" tone={isClose ? 'gold' : 'cyan'} size="sm" />
    </Panel>
  );
}

export default Stats;
